module.exports = __webpack_public_path__ + "img/betcalc.52d890d4.png";